import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertTriangleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.01886 1.52212C7.31839 1.35348 7.65632 1.26489 8.00005 1.26489C8.34379 1.26489 8.68172 1.35348 8.98125 1.52212C9.28078 1.69076 9.53178 1.93374 9.71005 2.22764L9.71197 2.2308L15.3586 11.6575L15.364 11.6667C15.5387 11.9691 15.6311 12.312 15.6321 12.6612C15.633 13.0104 15.5426 13.3538 15.3696 13.6572C15.1967 13.9606 14.9473 14.2134 14.6463 14.3905C14.3454 14.5676 14.0033 14.6628 13.654 14.6667L13.6467 14.6668L2.34606 14.6667C1.99686 14.6629 1.65475 14.5676 1.35377 14.3905C1.05279 14.2134 0.803423 13.9606 0.630487 13.6572C0.457552 13.3538 0.367072 13.0104 0.36805 12.6612C0.369028 12.312 0.461429 11.9691 0.636061 11.6667L0.641476 11.6575L6.28814 2.23081L6.86004 2.57338L6.29005 2.22764C6.46833 1.93374 6.71933 1.69076 7.01886 1.52212ZM7.43086 2.91781L1.78851 12.3373C1.73173 12.4371 1.7017 12.55 1.70138 12.6649C1.70105 12.7813 1.73121 12.8958 1.78886 12.9969C1.8465 13.0981 1.92962 13.1823 2.02995 13.2414C2.1294 13.2999 2.24232 13.3316 2.35765 13.3334H13.6425C13.7578 13.3316 13.8707 13.2999 13.9702 13.2414C14.0705 13.1823 14.1536 13.0981 14.2113 12.9969C14.2689 12.8958 14.2991 12.7813 14.2987 12.6649C14.2984 12.55 14.2684 12.4372 14.2116 12.3373L8.57005 2.91914C8.56979 2.9187 8.56952 2.91826 8.56925 2.91781C8.50987 2.82044 8.42651 2.73993 8.32712 2.68397C8.22728 2.62776 8.11463 2.59823 8.00005 2.59823C7.88548 2.59823 7.77283 2.62776 7.67299 2.68397C7.5736 2.73993 7.49023 2.82044 7.43086 2.91781Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.00004 5.33325C8.36823 5.33325 8.66671 5.63173 8.66671 5.99992V8.66658C8.66671 9.03477 8.36823 9.33325 8.00004 9.33325C7.63185 9.33325 7.33337 9.03477 7.33337 8.66658V5.99992C7.33337 5.63173 7.63185 5.33325 8.00004 5.33325Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.33337 11.3334C7.33337 10.9652 7.63185 10.6667 8.00004 10.6667H8.00671C8.3749 10.6667 8.67337 10.9652 8.67337 11.3334C8.67337 11.7016 8.3749 12.0001 8.00671 12.0001H8.00004C7.63185 12.0001 7.33337 11.7016 7.33337 11.3334Z",
			fill: "currentColor"
		})
	]
});
export default SvgAlertTriangleIcon;
